var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2089_1144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8364 29.498C24.472 17.6983 31.8454 8.79667 39.2514 5.84733V5.866C39.3424 4.72267 39.4917 3.69367 39.648 2.828C39.949 1.183 41.3934 0 43.0687 0H65.0184C78.6754 0 87.6377 15.9273 82.565 29.8713L79.0977 39.4077H34.342L29.8387 29.5003L29.8364 29.498Z",
    fill: "url(#paint0_linear_2089_1144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6667 112H23.3334C19.8613 112 16.5923 110.465 14.3687 107.786C12.1403 105.105 11.2303 101.603 11.8697 98.1772L15.1853 80.5116C16.331 74.3329 20.8367 69.4492 26.9384 67.7716L43.1154 63.3639C51.541 61.0656 60.4567 61.0656 68.887 63.3639L85.0593 67.7716H85.064C91.1657 69.4492 95.6714 74.3329 96.8194 80.5162L100.13 98.1749C100.77 101.6 99.862 105.103 97.6337 107.786C95.41 110.465 92.1387 112 88.6667 112Z",
    fill: "url(#paint1_linear_2089_1144)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M53.6667 74.6667H58.3334V112H53.6667V74.6667Z",
    fill: "url(#paint2_linear_2089_1144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6666 93.3334H32.6666C31.3763 93.3334 30.3333 92.2881 30.3333 91.0001C30.3333 89.7121 31.3763 88.6667 32.6666 88.6667H39.6666C40.957 88.6667 42 89.7121 42 91.0001C42 92.2881 40.957 93.3334 39.6666 93.3334Z",
    fill: "url(#paint3_linear_2089_1144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3333 60.6667H60.6667C69.6873 60.6667 77 67.9794 77 77.0001C77 79.5784 74.9117 81.6667 72.3333 81.6667H39.6667C37.0883 81.6667 35 79.5784 35 77.0001C35 67.9794 42.3127 60.6667 51.3333 60.6667Z",
    fill: "url(#paint4_linear_2089_1144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3333 56.0933V69.9999C44.3333 76.4423 49.5576 81.6666 56 81.6666C62.4423 81.6666 67.6666 76.4423 67.6666 69.9999V56.0933H44.3333Z",
    fill: "url(#paint5_linear_2089_1144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0023 56.0001H65.3333C64.043 56.0001 63 54.9547 63 53.6667C63 52.3787 64.043 51.3334 65.3333 51.3334H77.0023C78.2903 51.3334 79.3357 50.2857 79.3357 49.0001V42.0001C79.3357 40.7121 80.3787 39.6667 81.669 39.6667C82.9593 39.6667 84.0023 40.7121 84.0023 42.0001V49.0001C84.0023 52.8594 80.8617 56.0001 77.0023 56.0001Z",
    fill: "url(#paint6_linear_2089_1144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3333 46.6667H74.6666C73.3763 46.6667 72.3333 45.6213 72.3333 44.3333V30.3333C72.3333 29.0453 73.3763 28 74.6666 28H79.3333C83.1926 28 86.3333 31.1407 86.3333 35V39.6667C86.3333 43.526 83.1926 46.6667 79.3333 46.6667Z",
    fill: "url(#paint7_linear_2089_1144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 39.6667V35C25.6667 31.1407 28.8074 28 32.6667 28H37.3334C38.6237 28 39.6667 29.0453 39.6667 30.3333V44.3333C39.6667 45.6213 38.6237 46.6667 37.3334 46.6667H32.6667C28.8074 46.6667 25.6667 43.526 25.6667 39.6667Z",
    fill: "url(#paint8_linear_2089_1144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 46.6667V30.3333C35 25.179 39.179 21 44.3333 21H67.6667C72.821 21 77 25.179 77 30.3333V46.6667C77 51.149 75.2197 55.447 72.051 58.6157L67.9513 62.7153C64.7827 65.884 60.4847 67.6643 56.0023 67.6643C51.52 67.6643 47.222 65.884 44.0533 62.7153L39.9537 58.6157C36.785 55.447 35.0047 51.149 35.0047 46.6667H35Z",
    fill: "url(#paint9_linear_2089_1144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0023 55.9999H65.3333C64.043 55.9999 63 54.9546 63 53.6666C63 52.3786 64.043 51.3333 65.3333 51.3333H77.0023V55.9999Z",
    fill: "url(#paint10_linear_2089_1144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 49H58.3334C55.756 49 53.6667 51.0893 53.6667 53.6667C53.6667 56.244 55.756 58.3333 58.3334 58.3333H63C65.5773 58.3333 67.6667 56.244 67.6667 53.6667C67.6667 51.0893 65.5773 49 63 49Z",
    fill: "url(#paint11_linear_2089_1144)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2089_1144",
    x1: 27.286,
    y1: 7.00467,
    x2: 76.776,
    y2: 32.6877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2089_1144",
    x1: 56,
    y1: 64.2786,
    x2: 56,
    y2: 112.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4793EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2367EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2089_1144",
    x1: 56,
    y1: 80.7754,
    x2: 56,
    y2: 111.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B50D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182EA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2089_1144",
    x1: 30.4336,
    y1: 88.6504,
    x2: 41.5356,
    y2: 93.2004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2089_1144",
    x1: 56,
    y1: 63.3874,
    x2: 56,
    y2: 80.8734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FC6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50A7F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2089_1144",
    x1: 45.8616,
    y1: 61.7516,
    x2: 67.263,
    y2: 72.1839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1D2BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2089_1144",
    x1: 73.5,
    y1: 44.9284,
    x2: 73.5,
    y2: 55.4634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA5A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2089_1144",
    x1: 79.3333,
    y1: 28.609,
    x2: 79.3333,
    y2: 46.8253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4793EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2367EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2089_1144",
    x1: 32.6667,
    y1: 28.609,
    x2: 32.6667,
    y2: 46.8253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4793EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2367EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2089_1144",
    x1: 56,
    y1: 22.456,
    x2: 56,
    y2: 67.8953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1D2BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#F2CFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#F5C7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894,
    stopColor: "#FBBB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2089_1144",
    x1: 70,
    y1: -0.0000832241,
    x2: 70,
    y2: 55.4633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA5A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2089_1144",
    x1: 60.6667,
    y1: 48.762,
    x2: 60.6667,
    y2: 57.3277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4793EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2367EC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2089_1144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerService);
export default __webpack_public_path__ + "static/media/customer-service.03519554721821dfc6a2a64ebfaba678.svg";
export { ForwardRef as ReactComponent };